// DEV-ONLY · PRÜFMAPPE / BG-PRÜFPAKET (Preview) — Frozen Visual Standard.
// Operator-Entscheid (30.09.2026): KEIN neuer Screenshot; die bestehende
// BG-Prüfpaket-Darstellung ist inhaltliche Grundlage und wird hochwertig neu
// aufbereitet in den fotorealistischen CL-Mac integriert (device-pruefmappe.webp).
//  · Echte, code-belegte ZIP-Struktur 00–08 (bg_package.py). „Weltfreigaben" →
//    neukundenverständlich „Freigaben" (Funktion unverändert).
//  · 08 Führerscheinkontrollen [FÜHRERSCHEIN-MODUL]: Backend-Gap GESCHLOSSEN
//    (30.09.2026) — build_bg_package erzeugt nun 08_Fuehrerscheine/ mit den
//    PDF-Prüfnachweisen entschiedener FSK-Records (freigegeben + abgelehnt),
//    CSV-Zeilen + Audit-Sektion. KEINE Führerschein-Fotos im Paket.
//  · Chris groß (Pose 17), zeigt zum Mac. Keine Technikwerbung (WORM/SHA-256).
// Live `/abo` bleibt UNBERÜHRT bis zur Sichtabnahme (STOP-GATE).
import { useEffect, useRef } from "react";
import AboChris from "@/components/abo/AboChris";
import "@/pages/abo/abo.css";

const DEV = (n) => `/abo/devices/${n}`;
const OUTFIT =
  "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap";

export default function AboPruefmappeDevPreview() {
  const ref = useRef(null);
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = OUTFIT;
    document.head.appendChild(link);
    ref.current?.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"));
    return () => link.remove();
  }, []);

  return (
    <div className="abo-root" lang="de" ref={ref} data-testid="abo-pruefmappe-dev" style={{ minHeight: "100vh" }}>
      <style>{`
        [data-testid="abo-pruefmappe-dev"] .reveal{opacity:1 !important;transform:none !important;}
        [data-testid="abo-pruefmappe-dev"] .dev-label{max-width:1280px;margin:0 auto;padding:22px 24px 0;font:600 .72rem/1.4 "Outfit",sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#94a3b8;}

        [data-testid="abo-pruefmappe-dev"] .pm-stage{background:radial-gradient(120% 120% at 15% -10%, #eef5fb 0%, #f4f7f6 46%, #eef6f1 100%);padding:60px 0 74px;}
        [data-testid="abo-pruefmappe-dev"] .pm-wrap{max-width:1280px;margin:0 auto;padding:0 24px;}
        [data-testid="abo-pruefmappe-dev"] .pm-head{max-width:900px;margin:0 0 8px;}
        [data-testid="abo-pruefmappe-dev"] .pm-meta{display:flex;align-items:center;gap:12px;margin-bottom:14px;}
        [data-testid="abo-pruefmappe-dev"] .pm-kicker{font:600 .8rem/1 "Outfit",sans-serif;letter-spacing:.14em;text-transform:uppercase;color:var(--green-deep);}
        [data-testid="abo-pruefmappe-dev"] .pm-badge{font:600 .66rem/1 "Outfit",sans-serif;letter-spacing:.1em;text-transform:uppercase;color:#0f6b4a;background:#e6f6ee;border:1px solid #bfe6d2;border-radius:999px;padding:6px 11px;}
        [data-testid="abo-pruefmappe-dev"] .pm-title{font-family:var(--font-display,"Outfit",sans-serif);font-weight:700;color:var(--ink);font-size:clamp(2rem,3.4vw,3rem);line-height:1.05;margin:0 0 12px;letter-spacing:-.01em;}
        [data-testid="abo-pruefmappe-dev"] .pm-sub{font:500 1.05rem/1.5 "Outfit",sans-serif;color:var(--body,#475569);margin:0;}
        [data-testid="abo-pruefmappe-dev"] .pm-note{font:600 .82rem/1 "Outfit",sans-serif;letter-spacing:.04em;color:var(--green-deep);margin:16px 0 0;}
      `}</style>

      <div className="dev-label">Prüfmappe · Preview · CL-Mac + reale BG-Prüfpaket-Struktur · Live /abo unberührt</div>

      <section className="pm-stage" data-testid="pm-stage">
        <div className="pm-wrap">
          <header className="pm-head reveal">
            <div className="pm-meta">
              <span className="pm-kicker">Prüfmappe</span>
              <span className="pm-badge" data-testid="pm-badge">Grundabo</span>
            </div>
            <h2 className="pm-title" data-testid="pm-title">
              Berufsgenossenschaft vor der Tür? Ihre Nachweise sind schon bereit.
            </h2>
            <p className="pm-sub">Prüfmappe herunterladen statt Unterlagen zusammensuchen.</p>
            <p className="pm-note">Alle Nachweise. Eine Prüfmappe. Ein Download.</p>
          </header>

          {/* CL-Mac (echte BG-Prüfpaket-Struktur) links · Chris rechts, Pose 17 zeigt zum Mac */}
          <div className="abo-devb4-grid gh-scene reveal" data-testid="pm-scene">
            <figure className="abo-clmon abo-devb4-monitor" data-testid="pm-mac">
              <img
                src={DEV("device-pruefmappe.webp")}
                alt="CLartext Prüfmappe auf einem hochwertigen Desktop-Gerät: BG-Prüfpaket als ein Download mit Deckblatt, Nachweisliste, Freigaben, Unterweisungen, Prüfprotokoll, Wirksamkeitskontrollen, Gefahrstoffen, Handschutzplänen und Führerscheinkontrollen."
                data-testid="pm-shot"
                loading="eager"
                draggable="false"
              />
            </figure>
            <div className="abo-devb4-chris abo-chrisgrp" data-testid="pm-chris-wrap">
              <AboChris
                pose={17}
                size="md"
                testId="pm-chris"
                text="Die Berufsgenossenschaft möchte Ihre Nachweise sehen? Sie suchen nicht. Sie laden die Prüfmappe herunter."
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
